import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-careconformation',
  templateUrl: './careconformation.component.html',
  styleUrls: ['./careconformation.component.css'],
})
export class CareconformationComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CareconformationComponent>, public router: Router) {
    //////console.log("hello")
  }

  ngOnInit() { }

  onYesClick(): void {
    this.dialogRef.close(true);
    this.router.navigateByUrl('/login')
  }

}
